import { Button, Link, Menu, Tooltip } from '@lego/klik-ui';
import { FlagSwallowtailSolid } from '@lego/klik-ui/icons';
import { emmaGithubURL, emmaTeamsChannelUrl } from '@/utility/external_urls';

export const Issues = {
  reportIssueToTeams: {
    link: emmaTeamsChannelUrl,
    label: 'Report Issue to Teams Channel',
  },
  createFeatureRequest: {
    link: `${emmaGithubURL}/issues/new?template=2_feature_request.yml`,
    label: 'Create Feature Request',
  },
  reportIssue: {
    link: `${emmaGithubURL}/issues/new?template=3_bug_report.yml`,
    label: 'Report Bug',
  },
};

export const ReportIssue = () => {
  return (
    <Menu placement="top-end">
      <Tooltip label="Are you experiencing an issue?" placement="right">
        <Menu.Button
          _active={{ backgroundColor: 'white', color: 'red' }}
          _hover={{ backgroundColor: 'white', color: 'red' }}
          as={Button}
          backgroundColor="red"
          borderColor="red"
          borderWidth={2}
          color="white"
          fontSize="md"
          mr={2}
          rounded="full"
          size="sm"
          textAlign="center"
        >
          <FlagSwallowtailSolid />
        </Menu.Button>
      </Tooltip>
      <Menu.List p={2}>
        {Object.values(Issues).map((issue) => (
          <Menu.Item as={Link} href={issue.link} key={issue.label} target="_blank">
            {issue.label}
          </Menu.Item>
        ))}
      </Menu.List>
    </Menu>
  );
};
